/**
 * PartnerSection - Partner linking and management
 */
import { Button } from "@/components/ui/button";
import { Heart, Copy, Check, Link2, Unlink } from "lucide-react";

const PartnerSection = ({ 
  user, 
  copied, 
  onCopyInviteCode, 
  onLinkPartner, 
  onUnlinkPartner 
}) => {
  return (
    <section className="bg-card rounded-2xl border border-charcoal/5 shadow-card overflow-hidden animate-fade-in">
      <div className="p-6 border-b border-charcoal/5">
        <div className="flex items-center gap-2 mb-1">
          <Heart className="w-5 h-5 text-coral" />
          <h2 className="font-serif text-xl font-medium text-charcoal">Partner</h2>
        </div>
        <p className="text-sm text-muted-foreground">
          Share your bucket list with someone special
        </p>
      </div>

      <div className="p-6 space-y-4">
        {user.partner_id ? (
          <div className="space-y-4">
            <div className="flex items-center gap-3 p-4 bg-coral/5 rounded-xl border border-coral/20">
              <div className="w-12 h-12 rounded-full bg-coral/20 flex items-center justify-center">
                <Heart className="w-6 h-6 text-coral" />
              </div>
              <div>
                <p className="font-medium text-charcoal">{user.partner_name}</p>
                <p className="text-sm text-muted-foreground">Linked partner</p>
              </div>
            </div>
            
            <Button
              variant="outline"
              onClick={onUnlinkPartner}
              className="w-full h-12 text-red-600 hover:text-red-700 hover:bg-red-50 rounded-xl border-red-200"
              data-testid="unlink-partner-btn"
            >
              <Unlink className="w-4 h-4 mr-2" />
              Unlink Partner
            </Button>
          </div>
        ) : (
          <div className="space-y-4">
            {/* Your Invite Code */}
            <div className="p-4 bg-primary/5 rounded-xl border border-primary/20">
              <p className="text-sm text-muted-foreground mb-2">Your invite code</p>
              <div className="flex items-center gap-2">
                <code className="flex-1 text-lg font-mono font-bold text-charcoal tracking-widest">
                  {user.invite_code}
                </code>
                <Button
                  variant="ghost"
                  size="sm"
                  onClick={onCopyInviteCode}
                  className="h-9 px-3"
                  data-testid="copy-invite-code-btn"
                >
                  {copied ? (
                    <Check className="w-4 h-4 text-green-500" />
                  ) : (
                    <Copy className="w-4 h-4" />
                  )}
                </Button>
              </div>
              <p className="text-xs text-muted-foreground mt-2">
                Share this code with your partner
              </p>
            </div>

            <Button
              onClick={onLinkPartner}
              className="w-full h-12 bg-coral text-white hover:bg-coral/90 rounded-xl btn-press"
              data-testid="link-partner-btn"
            >
              <Link2 className="w-4 h-4 mr-2" />
              Link with Partner
            </Button>
          </div>
        )}
      </div>
    </section>
  );
};

export default PartnerSection;
